<div class="row">
    <div class="col-12 col-md-4">
        <div class="card rounded-0" >
            <div class="card-header">
                <div class="card-title mb-0">
                    <strong>Promotion Category</strong>
                </div>
            </div>
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <div class="mb-3">
                        <label for="title" class="form-label">Title <em>*</em></label>
                        <input type="text" class="form-control" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required>
                    </div>

                    <div class="mb-3">
                        <label for="image" class="form-label">Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'image')" [loadImage]="data.image"  (deleteEvent)="delete($event, 'image')" ></app-image-uploader>
                        <p class="mb-0 hint">This is the image of the promotion category. You could upload the image of the promotion category. The image will be displayed on the promotion category page.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [key]="'image_fullwidth'" [title]="'Image Fullwidth'" [setData]="data" [value]="true"></app-checbox>
                        <p class="mb-0 hint">This is the image fullwidth of the promotion category. You could select the image fullwidth of the promotion category. The image will be displayed on the promotion category page.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [key]="'image_clickable'" [title]="'Image Clickable'" [setData]="data" [value]="true"></app-checbox>
                        <p class="mb-0 hint">This is the image clickable of the promotion category. You could select the image clickable of the promotion category.</p>
                    </div>

                    <div class="mb-3" *ngIf="data.image_clickable">
                        <label for="popup_image" class="form-label">Popup Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'popup_image')" [loadImage]="data.popup_image"  (deleteEvent)="delete($event, 'popup_image')" ></app-image-uploader>
                        <p class="mb-0 hint">This is the popup image of the promotion category. You could upload the popup image of the promotion category. The popup image will be displayed on the promotion category page when the image is clicked.</p>
                    </div>

                    <div class="mb-3">
                        <label for="sort" class="form-label">Sort <em>*</em></label>
                        <input type="number" class="form-control" id="sort" name="sort" #sort="ngModel" [(ngModel)]="data.sort" required>
                        <div *ngIf="f.submitted && sort.invalid" class="invalid-feedback">
                            <div *ngIf="sort.errors.required">Sort is required</div>
                        </div>
                        <p class="mb-0 hint">This is the sort of the promotion category. You could set the sort of the promotion category.</p>
                    </div>

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>
